import { ChevronLeftIcon, ChevronRightIcon } from "@radix-ui/react-icons"
import cn from "classnames"
import { useRef } from "react"
import Slider from "react-slick"
import { DynamicHeadline } from "../DynamicHeadline"
import Section from "../Section"
import BlockQuote from "./BlockQuote"
import styles from "./BlockQuotes.module.scss"

const BlockQuotes = ({ data = {}, content = {}, colors }) => {
  const {
    quotes,
    dynamic_headline: dynamicHeadline,
    headline_appearance: headlineAppearance,
    headline_type: headlineType,
    ankerslug,
    quotes_type,
  } = data

  const sliderRef = useRef(null)
  const sliderSettings = {
    arrows: false,
    centerMode: false,
    infinite: true,
    // fade: true,
    slidesToShow: 1,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 5000,
  }

  const quoteElements = quotes.map((quote, i) => {
    return (
      <BlockQuote
        key={i}
        data={quote}
        content={content}
        locale={content.locale}
      />
    )
  })

  return (
    <Section
      id={ankerslug}
      sectionSpacing={{
        top: data?.section_padding_top?.value || null,
        bottom: data?.section_padding_bottom?.value || null,
      }}
      className={cn(styles.section, {
        [styles[`BlockQuotes--${content.locale}`]]: content.locale,
      })}
      colors={colors}
    >
      {dynamicHeadline && (
        <DynamicHeadline
          headlineType={headlineType.value}
          headlineAppearance={headlineAppearance.value}
          className={styles.headline}
        >
          {dynamicHeadline}
        </DynamicHeadline>
      )}
      <div className={styles.wrapper}>
        {quotes_type?.value === "slider" ? (
          <>
            <Slider ref={sliderRef} {...sliderSettings}>
              {quoteElements}
            </Slider>
            <div
              className={cn(styles.sliderControls, {
                [styles.sliderAbove]: Boolean(dynamicHeadline),
              })}
            >
              <button
                className={cn("button", styles.prevButton, styles.highlight)}
                aria-label="Zum vorherigen Kundenzitat wechseln"
                onClick={() => sliderRef?.current?.slickPrev()}
              >
                <ChevronLeftIcon aria-hidden />
              </button>
              <button
                className={cn("button", styles.nextButton, styles.highlight)}
                aria-label="Zum nächsten Kundenzitat wechseln"
                onClick={() => sliderRef?.current?.slickNext()}
              >
                <ChevronRightIcon aria-hidden />
              </button>
            </div>
          </>
        ) : (
          <div className={styles.blockQuotes}>{quoteElements}</div>
        )}
      </div>
    </Section>
  )
}

export default BlockQuotes
